import script from "./AccordionList.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionList.vue?vue&type=script&setup=true&lang=js"

import "./AccordionList.vue?vue&type=style&index=0&id=635032e2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-635032e2"]])

export default __exports__